import { combineReducers } from 'redux'
import tasks from './tasks'
import { conversations, messages } from './conversations-messages'
import current from './current'
import account from './account'
import appointmentTypes from './appointment-types'
import notifications from './notifications'
import messageSettings from './message-settings'
import patientGroups from './patient-groups'
import blastMessages from './blast-messages'
import selectedPatient from './selected-patient'
import callLog from './call-log'
import activeHours from './active-hours'
import aiAssistant from './ai-assistant'

export default combineReducers({
  account,
  activeHours,
  appointmentTypes,
  blastMessages,
  callLog,
  conversations,
  current,
  messages,
  messageSettings,
  notifications,
  patientGroups,
  selectedPatient,
  tasks,
  aiAssistant,
})



// WEBPACK FOOTER //
// ./src/state/reducers/index.js